export const paramTypeMap: Record<string, string> = {
  note: 'notes',
  template: 'templates',
  source: 'userSources',
};

export const typeFilterKey = 'type';
export const searchFilterKey = 'search';
export const includedTagIdsFilterKey = 'includedTagIds';
export const excludedTagIdsFilterKey = 'excludedTagIds';
export const updatedSinceFilterKey = 'updatedSince';
export const updatedToFilterKey = 'updatedTo';
export const datePresetFilterKey = 'datePreset';

export const defaultSearchableTypes = ['notes', 'templates', 'blocks'];

export const libraryTypeFilters = [
  {
    id: 'all',
    name: 'All',
  },
  {
    id: 'notes',
    name: 'Notes',
  },
  {
    id: 'templates',
    name: 'Templates',
  },
  {
    id: 'blocks',
    name: 'Blocks',
  },
];

export const tagsTypeFilters = [
  ...libraryTypeFilters,
  {
    id: 'userSources',
    name: 'Cortex',
  },
  /*  {
    id: 'instructions',
    name: 'Instructions',
  },*/
];

export const taggableTypes = ['notes', 'templates', 'blocks', 'userSources'];
